import { normalize } from 'normalizr'
import { arrayOfCategories } from '../../easymsCategorySchema'

export default categories => {
    // we need only id and names
    const parsedCategories = categories.map(c => ({
        id: c.id,
        name: c.name,
        shortName: c.shortName
    }))

    return normalize(parsedCategories, arrayOfCategories)
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/easymsParsers/easymsCategories.js